import { addHours, differenceInSeconds } from 'date-fns';
import { getLastShift } from '../shared/helpers/eligibilityChecks';
import { Job } from '../shared/models/job';
import { militaryTimeToMinutes } from '../shared/helpers/time';

export function getTimeSinceJobFinished(job: Job): number {
  let now = new Date();
  const shiftEnd = getLastShift(job.shifts).to;
  const lastShift = getLastShift(job.shifts);
  const isOverNight =
    militaryTimeToMinutes(lastShift.to.toString()) <
    militaryTimeToMinutes(lastShift.from.toString());
  const shiftEndString = shiftEnd.toString();
  const shiftHours =
    parseInt(shiftEndString.slice(0, shiftEndString.length - 2), 10) || 0;
  const jobDate = new Date(job.date);

  //+2 because user should be notified two hours later
  let endDate = addHours(jobDate, shiftHours + 2);
  if (isOverNight) {
    endDate = addHours(endDate, 24);
  }
  return differenceInSeconds(endDate, now);
}
